import { useState } from 'react';
import { ManualLegDto } from '../../../types';

interface Props {
  onClose: any;
  manualLegList: ManualLegDto[];
  setManualLegList: any;
  item: ManualLegDto;
  index: number;
}
const EditLegTypeModal = ({
  onClose,
  manualLegList,
  setManualLegList,
  item,
  index,
}: Props) => {
  const [selectedType, setSelectedType] = useState(item.type);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const saveHandle = () => {
    if (selectedType !== item.type) {
      const updatedLegList = [...manualLegList];
      updatedLegList[index] = {
        ...item,
        type: selectedType,
        postfix: selectedType,
      };
      setManualLegList(updatedLegList);
    }

    onClose();
  };
  return (
    <div
      className='modal'
      id='edit_leg_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='edit_legs_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      <div className='modal-dialog modal-lg'>
        <div className='modal-content'>
          <div className='modal-header'>
            <h4 className='modal-title text-center ' id='myModalLabel'>
              Edit Leg Type
            </h4>
          </div>
          <div className='modal-body'>
            <div className='p-3'>
              <label htmlFor='edit_leg_type' className='form-label'>
                Type
              </label>
              <select
                className='form-select dropdown-style w-100'
                id='edit_leg_type'
                aria-label='Leg'
                value={selectedType}
                onChange={(e) => {
                  setSelectedType(e.target.value);
                }}
              >
                <option value='' disabled>
                  Select Leg Type
                </option>
                <option
                  value='P'
                  disabled={manualLegList.some((item) => item.type === 'P')}
                >
                  Pickup
                </option>
                <option
                  value='M'
                  disabled={manualLegList.some((item) => item.type === 'M')}
                >
                  Main
                </option>
                <option
                  value='D'
                  disabled={manualLegList.some((item) => item.type === 'D')}
                >
                  Delivery
                </option>
              </select>
              <div className='invalid-feedback' id='edit_leg_type_error'></div>
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={onClose}
                >
                  Close
                </button>
                <button
                  type='button'
                  className='btn btn-ubbe'
                  onClick={saveHandle}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditLegTypeModal;
